import React               from 'react';
import { Link }            from 'react-router-dom';
import { getRoute }        from 'pursuit/routes/routes';
import OurTeamProfilePhoto from 'pursuit/components/Widgets/OurTeamProfilePhoto';

export default function TeamTile(props) {
        let classNames = 'home-our-team--tile';

        if (props.active === true) {
            classNames += ' active';
        }

        if (typeof props.className !== 'undefined') {
            classNames += ' '+props.className;
        }

    return (
        <div className={classNames}>
            <div className="grid-noGutter">
                <div className="col-6_xs-12 home-our-team--photo">
                    <OurTeamProfilePhoto profile={props.firstName} />
                </div>
                <div className="col-6_xs-12 home-our-team--details">
                    <h3>{props.fullName}</h3>
                    <div
                        className="home-our-team--details-letters"
                        dangerouslySetInnerHTML={{__html: props.letters}}
                    />
                    <div
                        className="home-our-team--details-profession"
                        dangerouslySetInnerHTML={{__html: props.profession}}
                    />
                    <div className="home-our-team--details-minibio"
                        dangerouslySetInnerHTML={{__html: props.bio}}
                    />

                    <div className="home-our-team--details-link">
                        <Link
                            to={getRoute('ourTeamMember', {member: props.slug})}
                        >
                            View {props.firstName}'s Profile
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
